import React, {useEffect} from "react";
import {auth} from "../../firebase";
import {createUserWithEmailAndPassword,} from "firebase/auth";

function AdminSignup({}) {
    const addUser = async () => {
        const email = "admin@buildmystory.com";
        const password = "12345678";
        const firebaseResponse = await createUserWithEmailAndPassword(auth, email, password);
    };

    useEffect(() => {
        addUser();
    }, [])

    return <div className="App mx-auto">Signup ADMIN</div>;
}

export default AdminSignup;